import Loadable from 'components/Loadable';
import { lazy } from 'react';
import { RouteObject } from 'react-router';

const Inquiry = Loadable(lazy(() => import('./index')))
const List = Loadable(lazy(() => import('./list/index')))
const Form = Loadable(lazy(() => import('./form/index')))

const Approval = Loadable(lazy(() => import('./approval/index')))
const ApprovalForm = Loadable(lazy(() => import('./approval/form/index')))

export const routes: RouteObject[] = [
    {
        path: '/list/kelola-nasabah/blokir-hak-akses-bsya-junior',
        children: [
            {
                index: true,
                element: <Inquiry />,
            },
            {
                path: ':id',
                element: <List />,
            }
        ]
    },

    {
        path: '/form/kelola-nasabah/blokir-hak-akses-bsya-junior/:id',
        element: <Form />,
    },

    {
        path: '/list/persetujuan/blokir-hak-akses',
        element: <Approval />
    },

    {
        path: '/form/persetujuan/blokir-hak-akses/:id',
        element: <ApprovalForm />,
    }
];
